import type { YmdRoute } from '@yoummday/ymmd-router/dist/types';

export default <Record<string, YmdRoute>>{
	'/': {
		as: 'example',
		module: () => import('.'),
	},
};
